import React from "react";
import Section from "./Section";
import { publications } from "../data/PublicationDetails";

const Publications = () => (
  <Section
    id="publications"
    title="Publications"
    subtitle="Research I've co-authored and published."
  >
    <ol className="space-y-4">
      {publications.map((pub) => (
        <li
          key={pub.title}
          className="grid gap-1 rounded-2xl border border-line bg-surface p-5 sm:grid-cols-[10rem_1fr] sm:gap-6 sm:p-6"
        >
          <p className="font-mono text-xs text-faint sm:pt-1">{pub.year}</p>
          <div>
            <h3 className="text-lg font-semibold">{pub.title}</h3>
            <p className="mt-1 flex flex-wrap items-center gap-2">
              <span className="rounded-full border border-line px-2.5 py-0.5 text-xs font-medium text-fg">
                {pub.role}
              </span>
            </p>
            <p className="mt-2 text-sm text-faint">
              {pub.journalUrl ? (
                <a
                  href={pub.journalUrl}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="underline-offset-4 hover:text-fg hover:underline"
                >
                  {pub.journal}
                </a>
              ) : (
                pub.journal
              )}
              , {pub.issn}
            </p>
            <p className="mt-3 max-w-prose text-sm text-muted">
              {pub.description}
            </p>
            <a
              href={pub.pdf}
              target="_blank"
              rel="noopener noreferrer"
              download
              className="mt-4 inline-block rounded-full border border-line px-4 py-1.5 text-sm font-medium transition-colors duration-100 hover:border-fg"
            >
              Download paper ↓
            </a>
          </div>
        </li>
      ))}
    </ol>
  </Section>
);

export default Publications;
